

<div class="sus-profit list-circle padlist no-list circle-blue mb-footer">
    <!-- section 1 contents -->
    <div class="sec-1">
        <div class="container">
            <div class="row">
                <!-- title -->
                <div class="col-md-12 my-md-5 mb-5 sec-title">
                    <app-title-page [dataTitle]="dataTitle" [link]="'#profit-able'"></app-title-page>
                </div>
                <!-- detail -->
                <div class="col-md-12" id="profit-able">
                    <div class="lane-top pt-5">
                        <div class="row">
                            <div class="col-xl-5 col-lg-6 col-md-8">
                                <h6 class="mini-tit">{{ dataSection[0]?.title }}</h6>
                            </div>
                            <div class="col-md-12">
                                <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
    <!-- section 2 contents -->
    <div class="sec-2 my-5 bg-headline d-flex align-items-center"
        [ngStyle]="{'background-image' : 'url('+ apiAsset + dataSection[1]?.picture +')'}">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-7 ml-auto">
                    <h3>{{ dataSection[1]?.title }}</h3>
                </div>
            </div>
        </div>
    </div>
    <!-- section 3 contents  -->
    <div class="sec-3">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="desc text-justify" [innerHTML]="dataSection[1]?.content"></div>
                </div>
            </div>
        </div>
    </div>
</div>

